import styles from './Divider.module.scss';

type DividerProps = {
  spacing?: number;
  orientation?: 'horizontal' | 'vertical';
  crop?: number;
  className?: string;
}

const Divider = ({
  spacing,
  orientation = 'horizontal',
  crop = 0,
  className
}: DividerProps): React.JSX.Element => {
  const computedClassName = [
    orientation === 'horizontal' ? styles.horizontal : styles.vertical,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={computedClassName} style={{
      margin: orientation === 'horizontal' ? `${spacing}px 0` : `${crop}px ${spacing}px`,
    }}/>
  );
};

export default Divider;
